export const renameNameField = (selector: string) => {
  setTimeout(() => {
    const nameField = document.querySelector<HTMLInputElement>(selector);
    if (nameField) nameField.focus();
  });
};

export const renameTask = (taskId: string) => {
  renameNameField(`[data-task-id="${taskId}"] [data-task-name-field] input`);
};

export const removeMemoFromReactComponent = <Value extends object>(value: Value): Value => {
  if (value && '$$typeof' in value && 'type' in value)
    return removeMemoFromReactComponent<Value>((value as any).type);
  return value;
};
